export const useStyles = (theme) => ({
  listStyle: {
    listStyle: "none",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "row",
    [theme.breakpoints.down(960)]: {
      display: "block",
      width: "100%",
      flexDirection: "column",
      justifyContent: "center",
      height: "30vh",
    },
  },
  itemList: {
    marginRight: 20,
    [theme.breakpoints.down(960)]: {
      marginLeft: 0,
      marginBottom: 20,
    },
  },
  labelStyle: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    fontSize: 18,
    color: "#ffffff",
  },
  sectionMobile: {
    display: "flex",
    paddingRight: 20,
    [theme.breakpoints.up(960)]: {
      display: "none",
    },
  },
});
